<template>
  <div id="app">
    <div id="layout-wrapper">
      <header id="page-topbar" style="background-color: #1e1f24;">
        <div class="navbar-header" style="height: 50px;">
          <div class="d-flex">
            <!-- LOGO -->
<!--            <div class="navbar-brand-box">-->


<!--              <a class="logo logo-light" href="/">-->
<!--                <span class="logo-sm">-->
<!--                    <img alt="" height="22" src="https://themesbrand.com/skote/layouts/assets/images/logo-light.svg">-->
<!--                </span>-->
<!--                <span class="logo-lg">-->
<!--                    <img alt="" height="19" src="https://themesbrand.com/skote/layouts/assets/images/logo-light.svg">-->
<!--                </span>-->
<!--              </a>-->
<!--            </div>-->

            <button id="vertical-menu-btn" class="btn btn-sm px-3 font-size-24 header-item waves-effect" type="button">
              <i style="color:white" class='bx bx-menu'></i>
            </button>

            <span class="page-title ml-4">{{ $t(title) }} </span>

          </div>

          <div class="d-flex">
            <div class="dropdown d-inline-block">
              <button aria-expanded="false" aria-haspopup="true" class="btn header-item waves-effect" data-toggle="dropdown"
                      type="button">
                <img id="header-lang-img" :src="'/static/assets/images/flags/' + lang + '.jpg'" alt="Header Language"
                     height="16">
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item notify-item language" href="javascript:void(0);"
                   @click.prevent="changeLanguage('ru')">
                  <img alt="user-image" class="me-1" height="12" src="/static/assets/images/flags/ru.jpg"> <span
                  class="align-middle">Russian</span>
                </a>
                <a class="dropdown-item notify-item language" href="javascript:void(0);"
                   @click.prevent="changeLanguage('ro')">
                  <img alt="user-image" class="me-1" height="11" src="/static/assets/images/flags/ro.jpg"> <span
                  class="align-middle">Romanian</span>
                </a>
              </div>
            </div>
            <Dropdown v-if="user">
              <button id="page-header-user-dropdown" aria-expanded="false" aria-haspopup="true"
                      class="btn header-item waves-effect" data-bs-toggle="dropdown" type="button">
                <span key="t-henry" class="d-inline-block ms-1"  style="color:white" >{{ user.name }}</span>
                <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </button>
              <DropdownMenu slot="list">
                <DropdownItem @click="logUserOut">Logout</DropdownItem>
              </DropdownMenu>
            </Dropdown>


          </div>
        </div>
      </header>
      <!-- ========== Left Sidebar Start ========== -->
      <div v-if="user" class="vertical-menu">
        <div  class="d-flex align-items-center justify-content-between menu-header" style="margin-top: 20px">
          <div class="menu-block menu-title">{{ $t('menu.menu') }}</div>
          <button id="vertical-menu-btn-second" class="btn btn-sm px-3 header-item waves-effect" type="button">
            <i class='bx bx-menu'></i>
          </button>
        </div>
        <div class="h-100" data-simplebar="init">

          <!--- Sidemenu -->
          <div id="sidebar-menu">
            <!-- Left Menu Start -->
            <ul id="side-menu" class="metismenu list-unstyled">
              <!--              <li class="menu-title" key="t-menu">Menu</li>-->
              <li v-if="enableFor(['admin', 'super'])" class="clubs">
                <a class=" waves-effect" href="#/clubs">
                  <!-- <i class='bx bxs-group'></i> -->
                  <!-- <i class='bx bxs-group'></i> -->
                  <Icon type="ios-american-football"/>
                  <span>{{ $t('menu.clubs') }}</span>
                </a>
              </li>
              <li v-if="enableFor(['admin', 'super'])" class="users">
                <a class=" waves-effect" href="#/users/table">
                  <i class='bx bxs-group'></i>
                  <span>{{ $t('menu.users') }}</span>
                </a>
              </li>
              <li class="licenses">
                <a class=" waves-effect" href="#/licenses">
                  <i class='bx bxs-id-card'></i>
                  <span class="position-relative">
                    <span>{{ $t('menu.licenses') }}</span>
                    <span v-if="counter" class="badge-license d-flex" style="padding-left: 0;">{{ counter }}</span>
                  </span>
                </a>
              </li>
              <li class="competitions">
                <a class=" waves-effect" href="#/competitions">
                  <Icon type="md-trophy"/>
                  <span>{{ $t('menu.competitions') }}</span>
                </a>
              </li>


            </ul>
          </div>
          <!-- Sidebar -->

        </div>
        <div class="menu-bottom">

          <div class="d-flex d-super-flex">

            <div style="margin: 0 auto;">
              <div v-if="user" class="dropdown d-inline-block">
                <Icon aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" role="button"
                      type="ios-cog-outline"/>
                <span class="user-name">{{ user.name }} </span>
                <div class="dropdown-menu dropdown-menu-end lang-logout">
                  <a class="dropdown-item text-danger" href="#" @click="logUserOut"><i
                    class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Logout</a>
                </div>
              </div>
            </div>
            <div style="margin: 0 auto;">
              <div class="dropdown d-inline-block">
                <button aria-expanded="false" aria-haspopup="true" class="btn header-item waves-effect" data-toggle="dropdown"
                        type="button">
                  <img id="header-lang-img" :src="'/static/assets/images/flags/' + lang + '.jpg'" alt="Header Language"
                       height="16">
                </button>
                <div class="lang-drop dropdown-menu dropdown-menu-end">
                  <a class="dropdown-item notify-item language" href="javascript:void(0);"
                     @click.prevent="changeLanguage('ru')">
                    <img alt="user-image" class="me-1" height="12" src="/static/assets/images/flags/ru.jpg"> <span
                    class="align-middle">Russian</span>
                  </a>
                  <a class="dropdown-item notify-item language" href="javascript:void(0);"
                     @click.prevent="changeLanguage('ro')">
                    <img alt="user-image" class="me-1" height="11" src="/static/assets/images/flags/ro.jpg"> <span
                    class="align-middle">Romanian</span>
                  </a>
                </div>
              </div>

            </div>
            <span class="build-version">B: {{ version }}</span>
          </div>
        </div>


      </div>
      <!-- Left Sidebar End -->

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">

        <router-view/>
      </div>
      <!-- end main content-->

    </div>

  </div>
</template>

<script>
import {version} from '../../package'

export default {
  data() {
    return {
      version: version,
      user: null,
      title: '',
      lang: localStorage.getItem('lang') || 'ru',
      counter: 0,
      isCollapsed: false
    }
  },
  computed: {
    rotateIcon() {
      return [
        'menu-icon',
        this.isCollapsed ? 'rotate-icon' : ''
      ];
    },
    menuitemClasses() {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    }
  },
  methods: {
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    logUserOut() {
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");
      this.$router.push("/login");
    },

    disableFor(arr) {
      if (!this.user.role) return false;
      return !arr.includes(this.user.role[0])
    },
    enableFor(arr) {
      if (!this.user.role) return false;
      return arr.includes(this.user.role[0])
    },
    changeLanguage(lang) {
      localStorage.setItem("lang", lang);
      this.lang = lang;
      this.$i18n.locale = lang;
      this.$user.data.lang = lang;
      this.title = this.$t('menu.' + this.$route.matched[0].meta.title);
    },
    async getUnregisteredLicenses() {
      try {
        let response = await this.$http.post('/temp-license/list', {})
        this.counter = response.data.length
      } catch (error) {
        console.log(error);
      }
    }

  },
  created: async function () {
    let response = await this.$http.get("/user/me");
    localStorage.setItem('user', JSON.stringify(response.data));
    this.user = response.data;
    this.$user.data = response.data;
    if (this.enableFor(['super', 'admin'])) {
      this.getUnregisteredLicenses()
    }
    this.changeLanguage(localStorage.getItem("lang") || "ru");
    if (this.user.banned)
      this.logUserOut();
  },
  mounted() {
    let s = window.$;

    // let val = localStorage.getItem('menu.collpsed');
    // if (val !== null) {
    //   let isTrueSet = (val === 'true');
    //   s("body").toggleClass("vertical-collpsed", isTrueSet)
    // }

    if(992 >= s(window).width()) {
      s("body").toggleClass("vertical-collpsed")
    }
    setTimeout(()=>{
      s("#side-menu").metisMenu()
      s("#vertical-menu-btn").on("click", function(e) {
        e.preventDefault()
        s("body").toggleClass("sidebar-enable");
        s("body").toggleClass("vertical-collpsed")
      })

      s("#vertical-menu-btn-second").on("click", function(e) {
        console.log(e)
        e.preventDefault()
        s("body").toggleClass("sidebar-enable");
        992 <= s(window).width() ? s("body").toggleClass("vertical-collpsed") : s("body").removeClass("vertical-collpsed")
      })
    },500)

    let path = this.$route.path.split('/')[1]
    this.title = this.$t('menu.' + this.$route.matched[0].meta.title);
    document.title = this.$t('menu.' + this.$route.meta.title) + ' | Rugby';
   // console.log(this.$route.name, path, 'li.' + path)

    $('li.' + path).addClass('mm-active');
    $('li.' + path + ' a').addClass('active');

    this.$router.afterEach((to, from) => {
      //console.log('to.meta.title', to.name)
      if (to.meta.title)
        document.title = this.$t('menu.' + to.meta.title) + ' | Rugby';
      else
        document.title = 'VB Trans GmbH';

      $('li.mm-active a').removeClass('active');
      $('li.mm-active').removeClass('mm-active');
      this.title = this.$t('menu.' + to.matched[0].meta.title);
      let path = to.path.split('/')[1]
      $('li.' + path).addClass('mm-active');
      $('li.' + path + ' a').addClass('active');
    });
    let lang = this.lang === "ru" ? "Russian" : "Romanian"
    $('body').addClass(this.lang)

  }
}
</script>

<style scoped>
@import url("../assets/global.css");

.header-item {
  height: 100%;
}

.navbar-header .page-title {
    font-weight: 600;
    color: var(--text-color);
    border: none;
}

.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width .2s ease .2s;
}

.menu-item i {
  transform: translateX(0px);
  transition: font-size .2s ease, transform .2s ease;
  vertical-align: middle;
  font-size: 16px;
}

.collapsed-menu span {
  width: 0px;
  transition: width .2s ease;
}

.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size .2s ease .2s, transform .2s ease .2s;
  vertical-align: middle;
  font-size: 22px;
}


.vertical-collpsed .menu-block {
  display: none;
}

#sidebar-menu {
  padding-top: 5px;
}

.vertical-collpsed #sidebar-menu {
  padding-top: 0;
}

.build-version {
  font-size: 10px;
  color: #e0e0e0;
  width: 100%;
  text-align: center;
}

.badge-license {
  position: absolute;
  top: -10;
  right: -15;
  background: red;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  font-weight: bold;
  border: white 1px solid;
  font-size: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lang-drop {
  left: 70px !important;
  bottom: 0 !important;
  top: 0 !important;
  height: fit-content !important;
}

.lang-drop.dropdown-menu.show {

  top: 0 !important;
}

.lang-logout {
  left: 70px !important;
}

.d-super-flex {
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: space-between;
  /*padding-left: 0;*/
  margin-bottom: 0;
  font-size: 25px;
  padding: 10px 10px 10px 0;
  background: #4e566f;
  color: white;
}

.menu-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
}

#vertical-menu-btn-second{
  text-align: center;
  width: 70px;
  color: var(--burger-menu-btn);
  font-size: 25px;
}

#vertical-menu-btn-second:hover {
  color: var(--burger-hover-menu-btn);
  transition: all .4s;
}


.page-content {
  padding-top: 20px;
  padding-bottom: 20px;
  background: var(--bg-silver);
}

body {
  background: var(--bg-silver) !important;
}

.vertical-menu {
  top: 0;
}

.vertical-collpsed .vertical-menu {
  z-index: 13 !important;
  position: fixed !important;
}
.navbar-brand-box {
  display: flex;
  align-items: center;
}
.navbar-brand-box {
  background:var(--bg-darkness) !important;
}
.user-name {
  font-size: 14px;
}

.vertical-collpsed .user-name {
  display: none !important;
}

.mm-active {
  color: #fff !important;
}

#sidebar-menu .has-arrow:after {
  content: "\F116";
  font-family: 'Ionicons';
}

.layout-wrapper {
  height: 100%;
}

body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active i {
  color: #ffffff !important;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}
#page-topbar {
  display: none;
}

@media (max-width: 992px) {
  body{
    overscroll-behavior: none;
  }
  #page-topbar {
    display: inline;
  }
  .main-content {
    margin-left: 0px !important;
    overscroll-behavior: none;
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 0;
  }

  .main-content:has(.team-form-page) {
    position: relative;
  }
  .vertical-menu {
    width: 200px;
  }
  .menu-bottom {
    display:none;
  }
  .menu-header {
    margin-top: 0px !important;
  }
 /*
  .vertical-collpsed .vertical-menu {
    display: none !important;
  }
  .sidebar-enable .vertical-menu {
    display: block !important;
  }
  */
}

.dot-primary {
  background: white;
  border: 1px solid #2d8cf0;
  border-radius: 50%;
}

.dot-storno {
  background: #8000802e !important;
}

.dot-warning {
  background: #ffa50042 !important;
}

</style>




// WEBPACK FOOTER //
// src/components/EmptyRouterView.vue